module.exports = __webpack_public_path__ + "src/assets/img/focus_off.3234ba92.svg";